import type { MatrixListItemUi } from "@/domains/matrix";
import { getDaysAgo } from "@/shared/lib/format";

export function summarizeMatrix(matrix: MatrixListItemUi): string {
  if (matrix.rowCount === 0) return "No rows";
  return `${matrix.rowCount} ${matrix.rowCount === 1 ? "row" : "rows"}`;
}

// Compact form for the rail; the card's title carries the spelled out one.
export function formatMatrixAge(isoDate: string): string {
  const days = getDaysAgo(isoDate);
  if (days === 0) return "today";
  if (days < 7) return `${days}d`;
  if (days < 30) return `${Math.floor(days / 7)}w`;
  return `${Math.floor(days / 30)}mo`;
}
